import { Canvas } from '@react-three/fiber';
import { OrbitControls, PerspectiveCamera, Stars } from '@react-three/drei';
import ParticleField from './ParticleField';
import FloatingOrb from './FloatingOrb';
import ConnectionLines from './ConnectionLines';

export default function Scene3D() {
  return (
    <div className="fixed inset-0 -z-10">
      <Canvas>
        <PerspectiveCamera makeDefault position={[0, 0, 20]} />
        <OrbitControls
          enableZoom={false}
          enablePan={false}
          autoRotate
          autoRotateSpeed={0.8}
          maxPolarAngle={Math.PI / 2}
          minPolarAngle={Math.PI / 2}
        />
        
        <Stars radius={100} depth={50} count={5000} factor={4} saturation={0} fade speed={2} />
        
        <ambientLight intensity={0.5} />
        <pointLight position={[10, 10, 10]} intensity={1.5} color="#00ffff" />
        <pointLight position={[-10, -10, -10]} intensity={1.5} color="#ff00ff" />
        <pointLight position={[0, 10, -10]} intensity={1} color="#ffff00" />
        
        <ParticleField count={4000} />
        <ConnectionLines />
        
        <FloatingOrb position={[-5, 2, 0]} color="#00ffff" scale={0.8} />
        <FloatingOrb position={[5, -2, 0]} color="#ff00ff" scale={0.6} />
        <FloatingOrb position={[0, 3, -5]} color="#ffff00" scale={0.7} />
        <FloatingOrb position={[3, -3, 3]} color="#00ff00" scale={0.5} />
        <FloatingOrb position={[-3, -1, 5]} color="#ff0080" scale={0.9} />
      </Canvas>
    </div>
  );
}
